/**
 * SnapshotCacheLogger - Utility for logging snapshot caching operations
 * 
 * Extracted from TypesetterWorkerClient for better modularity and testability.
 * 
 * This utility provides functions for logging snapshot caching operations,
 * providing consistent logging format across the codebase.
 */

import type { ParagraphSnapshot } from '../../../core/types/Typesetter';
import { WasmLogger } from '../../../../../utils/loggers/WasmLogger';

/**
 * Log pagination result summary
 * 
 * @param result - Pagination result to log
 */
export function logPaginationResult(result: {
  pages: any[];
  next_cursor: any;
  telemetry: any;
}): void {
  WasmLogger.pagination.result(result.pages.length, result.next_cursor, result.telemetry);
}

/**
 * Log snapshot caching operation
 * 
 * @param snapshot - Snapshot that was cached
 * @param snapshotId - Snapshot ID that was assigned
 */
export function logSnapshotCached(
  snapshot: ParagraphSnapshot,
  snapshotId: string
): void {
  WasmLogger.snapshot.initialCached(snapshot.lines.length, !!snapshot.caret_map, snapshotId);
}

